export const Feedback_EN = {
  feedback: {
    heading: "Feedback",
    desc: "We would love to hear your feedback so we can improve our platform, Game Tracker, and your gaming experience.",
    fields: {
      type: {
        label: "Feedback type",
        bug: "Bug Report",
        feature: "Feature Request",
        general: "General Feedback",
        other: "Other",
      },
      details: {
        label: "What would you like to tell us?",
        placeholder: "Enter your message here...",
      },
      button: {
        label: "Submit",
      },
    },
    success: "Feedback submitted successfully!",
    error: "Error: ",
  },
};
